export default __webpack_public_path__ + "static/media/tapesh.00c6c595.png";